/*
 * Google Maps subset wrapper.
 * Google JS APIs use callbacks instead of promises, so basically we are wrapping them inside a Promise
 * constructor.
 * The main aim is to keep the google method signature and call, so
 *
 * new google.maps.places.PlacesService(map).textSearch({....}, callback)
 *
 * becomes
 *
 * new bbGoogleMaps.places.PlacesService(map).textSearch({....}).then((result, status) => {})
 */
class BBGoogleMaps {
    get places() {
        return {
            PlacesService(canvas) {
                return {
                    textSearch(params) {
                        return new Promise((resolve, reject) => {
                            new google.maps.places.PlacesService(canvas).textSearch(params, (results, status) => {
                                resolve(results, status);
                            });
                        });
                    }
                };
            }
        };
    }

    Geocoder() {
        return {
            geocode(params) {
                return new Promise((resolve, reject) => {
                    new google.maps.Geocoder().geocode(params, (results, status) => {
                        resolve(results, status);
                    });
                });
            }
        };
    }
}

angular
    .module('BB')
    .service('bbGoogleMaps', BBGoogleMaps);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/bb_google_maps.service.js